export default "__VITE_ASSET__Ci4rBlB7__"